import { useEffect } from "react";

export const useAssistantsVisibilityToggler = (isHidden: boolean) => {
  useEffect(() => {
    const targets = [
      () => document.getElementById("chatbase-bubble-button"),
      () => document.querySelector("[id^='sleeknote-']"),
      () => document.querySelector("iframe[src*='sleeknote']"),
    ];

    const updateVisibility = () => {
      targets.forEach((getEl) => {
        const el = getEl();

        if (el instanceof HTMLElement) {
          el.style.transition =
            "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out";
          el.style.opacity = isHidden ? "0" : "1";
          el.style.visibility = isHidden ? "hidden" : "visible";
          el.style.pointerEvents = isHidden ? "none" : "auto";
        }
      });
    };

    updateVisibility();

    const observer = new MutationObserver(() => {
      updateVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [isHidden]);
};
